import React, { useState, useEffect, useRef } from 'react'
import DatePicker from "react-datepicker";
import CalendarIcon from "../../../../assets/images/Icons/calendarIcon.svg";
import DownArrow from "../../../../../src/assets/images/Icons/icons/down_arrow.svg";
import UpArrow from "../../../../../src/assets/images/Icons/icons/up_arrow.svg";
import { makeAjax, respStatus, url, showMessage } from '../../../../helpers/global_helper';
import { useDispatch, useSelector } from "react-redux";
import { setTotalNoResult } from "../../../../redux/actions";
import { formatPricewithdecimal } from "../../../NumberFormat";
import { withTranslation } from "react-i18next";
import TurnoverDatePopup from './TurnoverDatePopup';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaCalendar } from "react-icons/fa";

const InfoTurnover = (props) => {
  const device = useSelector(state => state.CommonConfig.device_type);
  const dispatch = useDispatch()
  const [startDate, setStartDate] = useState(new Date());
  const [selectGameName, setSelectGameName] = useState("0");
  const [turnoverInfoData, setTurnoverInfoData] = useState([]);
  const [gameName, setGameName] = useState([]);
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [turnoverPopup, setTurnoverPopup] = useState(false);
  const [turnoverDateId, setTurnoverDateId] = useState(null);
  const pageNumber = useSelector((state) => state.paginationData.pageNumber)
  const perPage = useSelector((state) => state.paginationData.dataInOnePage)
  const debounceTimeout = useRef(null);
  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };
  const sortedData = () => {
    if (sortBy) {
      const sortedArray = turnoverInfoData.slice().sort((a, b) => {
        let aValue, bValue;

        if (sortBy === "created_date") {
          aValue = new Date(a[sortBy]);
          bValue = new Date(b[sortBy]);
        } else if (sortBy === "winlose" || sortBy === "tover") {
          aValue = parseFloat(a[sortBy].replace(/[^0-9.-]/g, ""));
          bValue = parseFloat(b[sortBy].replace(/[^0-9.-]/g, ""));
        } else {
          aValue =
            typeof a[sortBy] === "string" ? a[sortBy].toLowerCase() : a[sortBy];
          bValue =
            typeof b[sortBy] === "string" ? b[sortBy].toLowerCase() : b[sortBy];
        }

        if (sortBy === "winlose") {
          return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
        }

        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });

      return sortedArray;
    }
    return turnoverInfoData;
  };

  // api for Game list
  const featchGameList = () => {
    makeAjax(url.TOGEL_API.listGame).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setGameName(response.data);
    });
  };

  useEffect(() => {
    featchGameList();
  }, []);

  // api for Turnover Info list
  const fetchTurnoverInfo = () => {
    setLoading(true);
    let reqData = {
      page: pageNumber,
      length: parseInt(perPage)
    };

    makeAjax(url.PLAYER_API.listTurnover, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code !== "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setTurnoverInfoData(response.data.data);
      dispatch(setTotalNoResult(response.data.total));
      setLoading(false);
    });
  };

  useEffect(() => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      fetchTurnoverInfo();
    }, 500); 
    const container = document.querySelector('.table_container');
    if (container) {
      container.scrollTop = 0;
    }

    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [perPage, pageNumber]); 


  const openTurnoverDatePopup = (turnoverDateId) => {
    setTurnoverDateId(turnoverDateId);
    setTurnoverPopup(true);
  };

  const closeTurnoverDatePopup = () => {
    setTurnoverPopup(false);
  };


  return (
    <div className='trasaction_popup'>
      <div className={device === "Desktop" ? "informasi_tble_result" : "container"}>
        <table >
          <thead>
            <tr>
              <th onClick={() => handleSort("created_date")}>
                {props.t("date")}
                <span className="sorting_arrow">
                  {sortBy === "created_date" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("winlose")}>
                {props.t("win")} / {props.t("lose")}
                <span className="sorting_arrow">
                  {sortBy === "winlose" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("tover")}>
                {props.t("turnover")}
                <span className="sorting_arrow">
                  {sortBy === "tover" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              (sortedData().length === 0 ?
                <tr className="table_data_empty_row">
                  <td colSpan="3">{props.t("data_not_found")}</td>
                </tr> :
                (sortedData().map((item, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                  >
                    <td onClick={() => openTurnoverDatePopup(item.created_date)}>
                      <span className="link">{item.created_date}</span>
                    </td>
                    <td>{formatPricewithdecimal(item.winlose)}</td>
                    <td>{formatPricewithdecimal(item.tover)}</td>
                  </tr>
                ))))
            }
          </tbody>

        </table>
      </div>
      {turnoverPopup && (
        <TurnoverDatePopup
          onClose={closeTurnoverDatePopup}
          turnoverDateId={turnoverDateId}
        />
      )}
    </div>
  )
}

export default withTranslation()(InfoTurnover)